/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsWizerUser
 */
export interface JumboStructsWizerUser {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsWizerUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsWizerUser
     */
    role?: string;
}

/**
 * Check if a given object implements the JumboStructsWizerUser interface.
 */
export function instanceOfJumboStructsWizerUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsWizerUserFromJSON(json: any): JumboStructsWizerUser {
    return JumboStructsWizerUserFromJSONTyped(json, false);
}

export function JumboStructsWizerUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsWizerUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'role': !exists(json, 'role') ? undefined : json['role'],
    };
}

export function JumboStructsWizerUserToJSON(value?: JumboStructsWizerUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'role': value.role,
    };
}

